export class ApiService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  async getCommonData() {
    const cacheData = this.gaApp.services.cache.main.getServerData('common')
    const { data } =
      cacheData || (await this.gaApp.repositories.app.main.getCommonData())

    this.gaApp.stores.app.common.setData(data)
  }

  /**
   * Получение данных редиректа
   * Метод используется в public сервисе
   *
   * @param {object} params - объект параметров
   * @param {string} params.url - запрашиваемый url
   *
   * @returns {Promise}
   */
  getRedirectData(params, requestOptions = {}) {
    return this.gaApp.repositories.app.main.getRedirectData(
      params,
      requestOptions,
    )
  }
}
